import React, { useEffect, useCallback } from 'react'
import { Grid, Container, CircularProgress, Typography, Link } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import { UserRoleType } from '~api/models'
import * as wizardNewUserActions from '~store/wizardNewUser/actions'
import { getUserAsync } from '~store/account/selectors'
import { fetchUser } from '~store/account/actions'
import { useGlobalStyles } from '~shared/styles/globalStyles'
import logo from '~assets/logo-saf--big.png'

import { useRegistrationCustomerPortalStyles } from './RegistrationCustomerPortal.styles'
import NewUserFormWizard from './components/NewUserFormWizard/NewUserFormWizard'

import { useHistory } from 'react-router-dom'

interface Props {
  children: React.ReactNode
}

const RegistrationCustomerPortal: React.FC<Props> = (props) => {
  const s = useRegistrationCustomerPortalStyles()
  const gs = useGlobalStyles()
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const userAsync = useSelector(getUserAsync)
  const userFinishedRegistrationForm = !!userAsync.payload?.id
  const history = useHistory()

  // todo make this a helper function
  const navigate = useCallback((routeName: string) => () => {
    history.push(routeName)
  }, [history])

  // on mount
  useEffect(() => {
    dispatch(fetchUser.started())

    // eslint-disable-next-line -- only run on mount
  }, [])

  useEffect(() => {
    if (userFinishedRegistrationForm) dispatch(wizardNewUserActions.setCurrentStep('success'))
  }, [userFinishedRegistrationForm, dispatch])

  return (!userAsync.inProgress && !!userAsync.payload && userAsync.payload.role !== UserRoleType.UNREGISTERED)
    ? <>
      {props.children}
    </>
    : <div>
      <Container className={s.container} maxWidth={false}>
        <Grid container spacing={3}>
          <Grid container item xs={12} justifyContent='center'>
            <img
              src={logo} className={gs.logoBig}
            />
          </Grid>
          <Grid container item xs={12} justifyContent='center'>
            {
              userAsync.inProgress && (userAsync.inProgress || userAsync.error)
                ? <CircularProgress color='primary' />
                : (
                  userAsync.payload
                    ? <NewUserFormWizard />
                    : <p>{t('error:fetchUserError')}</p>
                )
            }
          </Grid>
          <Grid item xs={12}>
            <Container maxWidth='md'>
              <Link
                onClick={navigate('/dataProtection')}
                style={{
                  display: 'block',
                  textAlign: 'right',
                  cursor: 'pointer',
                }}
                underline='always'
              >
                {t('common:dataProtection')}
              </Link>
            </Container>
          </Grid>
        </Grid>
      </Container>
    </div>
}

export default RegistrationCustomerPortal
